import React, { useEffect } from "react";

const NotificationComponent = ({ newOrderId }) => {
  useEffect(() => {
    if (newOrderId) {
      console.log("New Order ID received for notification:", newOrderId);
      triggerNotification(newOrderId);
    }
  }, [newOrderId]);

  const triggerNotification = (orderId) => {
    console.log("Attempting to trigger notification for Order ID:", orderId);

    if (!("Notification" in window)) {
      alert("This browser does not support desktop notifications.");
      return;
    }

    if (Notification.permission === "granted") {
      console.log("Notification permission granted.");
      showNotification(orderId);
    } else if (Notification.permission !== "denied") {
      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          console.log("Notification permission granted.");
          showNotification(orderId);
        }
      });
    }
  };

  const showNotification = (orderId) => {
    console.log("Displaying notification for Order ID:", orderId);
    const notification = new Notification("New Order Received!", {
      body: `Order ID: ${orderId} has been added.`,
      icon: "tcclogo.jpg", // Replace with your icon URL
    });

    notification.onclick = () => {
      console.log("Notification clicked.");
      window.location.href = `./ordersummary/${orderId}`; // same tab redirect
    };
  };


  return null; // No UI needed for this component
};

export default NotificationComponent;

